

  export function findPathsToValue(obj, targetValue, currentPath = '') {
    let paths = [];
  
    for (const key in obj) {
      const value = obj[key];
      const path = currentPath ? `${currentPath}.${key}` : key;
  
      if (value === targetValue) {
        paths.push(path);
      } else if (typeof value === 'object' && value !== null) {
        paths = paths.concat(findPathsToValue(value, targetValue, path));
      }
    }
  
    return paths;
  }
